import { Box } from '@chakra-ui/react';
import { Code } from 'constants/keyboard';
import { AutoCompleteSearchInput } from 'modules/common/components/SearchInput/AutoCompleteSearchInput';
import { KeyboardEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { POPULAR_SEARCH_SUGGESTIONS } from './TemplateSearch.config';

interface TemplatesSearchInputProps {
  onSearch: (query: string) => void;
  query: string;
}

/**
 * TEMPLATES SEARCH INPUT COMPONENT
 *
 * Renders AutoComplete search input for templates
 */
export const TemplatesSearchInput = ({ onSearch, query }: TemplatesSearchInputProps) => {
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu.templatesMenu' });

  // Prevent closing the menu when pressing escape
  const stopPropagation = useCallback((e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === Code.Escape) e.stopPropagation();
  }, []);

  return (
    <Box onKeyDown={stopPropagation} w='full' h='full'>
      <AutoCompleteSearchInput
        onSearch={onSearch}
        placeholder={t('search.placeholder')}
        label={t('search.inputLabel')}
        autoCompleteList={POPULAR_SEARCH_SUGGESTIONS}
        defaultValue={query}
      />
    </Box>
  );
};
